import 'bootstrap';
import initResponsiveMenu from './components/responsive-menu';
import initEvents from './components/events';
import initStickyHeader from "./components/sticky-header";
document.addEventListener('DOMContentLoaded', function () {
  initResponsiveMenu();
  initEvents();
  initStickyHeader();
});